/**
 * SSO types and UI constants (schemas re-exported from shared).
 */

export {
  ConfigureSsoRequestSchema,
  ConfigureSsoResponseSchema,
  SsoLoginRequestSchema,
  SsoLoginResponseSchema,
  SsoTestConnectionResponseSchema,
  DisableSsoResponseSchema,
  type ConfigureSsoRequest,
  type ConfigureSsoResponse,
  type SsoLoginRequest,
  type SsoLoginResponse,
  type SsoTestConnectionResponse,
  type DisableSsoResponse,
} from '@cnapse/shared/schemas/sso.schemas.js';

import type * as dt from '@cnapse/shared/data.types.js';

/**
 * Tenant SSO Status (for displaying in UI)
 */
export interface TenantSsoStatus {
  ssoEnabled: boolean;
  ssoEnforcement: 'disabled' | 'optional' | 'required';
  ssoConfigured: boolean;
  samlIdpEntityId?: string | null;
  samlIdpSsoUrl?: string | null;
  samlIdpCertificate?: string | null;
  cognitoIdpName?: string | null;
  ssoJitProvisioning: boolean;
  ssoDefaultRole: dt.ALL_USER_ROLES;
  samlAttributeMapping: Record<string, string>;
  ssoConfiguredAt?: string | null;
  ssoConfiguredBy?: string | null;
}

/**
 * SAML Attribute Mapping defaults
 */
export const DEFAULT_SAML_ATTRIBUTE_MAPPING: Record<string, string> = {
  email: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress',
  firstName: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname',
  lastName: 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname',
};

/**
 * SSO Enforcement Mode descriptions
 */
export const SSO_ENFORCEMENT_DESCRIPTIONS = {
  disabled: 'SSO is disabled. Users can only use password authentication.',
  optional: 'Users can choose between SSO and password authentication.',
  required: 'SSO is mandatory. Password authentication is disabled.',
} as const;

/**
 * SAML Configuration input mode
 */
export type SamlInputMode = 'manual' | 'metadata';
